import { render } from "./PricingStatus.vue?vue&type=template&id=1c87a9ae"
import script from "./PricingStatus.vue?vue&type=script&lang=js"
export * from "./PricingStatus.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__